import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../../application/config/config";
import Fetch from "../../../util/core/Fetch";
import { getUserSession } from "../../../util/core/Session";
import CustomForm from "../Util/Form/CustomForm/CustomForm";
import CustomFormContainer from "../Util/Form/CustomForm/CustomFormContainer";
import Toast from "../Util/Toast/Toast";

function Form() {
  const session = getUserSession();
  const { id } = useParams();
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.session);
  const [tutorials, setTutorials] = useState([]);
  const [formContent, setFormContent] = useState(<></>)
  const navigate = useNavigate();
  const endpointBackend = config.endpoints.backend;
  const path = "/core/tutorial/";
  const paths = {
    endpointSave: endpointBackend + "core/tutorial/save",
    endpointGetById: endpointBackend + "core/tutorial/getByCoreApplicationInstanceId",
    pathView: path + "view",
  };

  const labels = {
    labelTitleAdd: "Tutoriais",
    labelTitleEdit: "Editar Tutorial",
    labelTitleView: "Tutorial",
  };

  const hiddenValuesToForm =
    session.user.application_id == config.admin_application_id
      ? {}
      : { application_id: session.user.application_id };

  useEffect(() => {
    dispatch({
      type: "UPDATE_SESSION",
      key: "tutorial_itens",
      value: tutorials,
    });
  }, [tutorials]);

  const handleSubmit = async (fields, values, loadData) => {
    Toast.success("Informações atualizadas com sucesso!")
  };

  const getForm = (values) => {
    const form = {
      validateOnChange: true,
      hiddenValues: {
        ...hiddenValuesToForm,
        core_application_instance_id: session.user.application_instance_id,
      },
      handleSubmit,
      fields: [
        {
          name: "tutorial_itens",
          type: "sortabletreetutorial",
          label: "Tutoriais",
          levelsLimit: 1,
          customStyles: "tutorial_management_tree",
          onChangeTreeData: async (treeData) => {
            const values = {
              id: id,
              tutorial_itens: treeData,
              core_application_instance_id: session.user.application_instance_id,
            };

            await Fetch.put(paths.endpointSave, values);
          },
          validations: {},
          fieldsForm: [
            {
              name: "title",
              type: "text",
              label: "Título",
              validations: {
                required: true,
              },
              maxLength: 35,
              columnSize: 12,
            },
            {
              name: "icon",
              type: "selectIcons",
              label: "Ícone",
              validations: {
                required: true,
              },
              columnSize: 12,
            },
            {
              type: "label",
              value: <label style={{ marginBottom: 0, marginBottom: -5 }}>Publicar Módulo <span style={{ color: "#dc3545" }}>*</span></label>,
              validations: {
                required: false,
              },
            },
            {
              name: "published",
              type: "checkbox",
              switch: true,
              label: "",
              validations: {
                required: false,
              },
              columnSize: 12,
            },
            {
              type: "label",
              value: <div style={{ margin: 0, marginTop: -24 }}></div>,
              validations: {
                required: false,
              },
            },
            {
              name: "description",
              type: "text",
              label: "Descrição",
              placeholder: "Descrição",
              validations: {
                required: true,
              },
              columnSize: 12,
            }
          ],
          childFieldsForm: [
            {
              name: "title",
              type: "text",
              label: "Título",
              validations: {
                required: true,
              },
              maxLength: 35,
              columnSize: 12,
            },
            {
              type: "label",
              value: <label style={{ marginBottom: 0, marginBottom: -5 }}>Publicar Tutorial <span style={{ color: "#dc3545" }}>*</span></label>,
              validations: {
                required: false,
              },
            },
            {
              name: "published",
              type: "checkbox",
              switch: true,
              label: "",
              validations: {
                required: false,
              },
              columnSize: 12,
            },
            {
              type: "label",
              value: <div style={{ margin: 0, marginTop: -24 }}></div>,
              validations: {
                required: false,
              },
            },
            {
              name: "description",
              type: "text",
              label: "Descrição",
              placeholder: "Descrição",
              validations: {
                required: true,
              },
              columnSize: 12,
            },
            {
              name: 'video',
              type: 'fileS3',
              label: 'Vídeo (.mp4)',
              uploadPath: 'crud_example_videos',
              extensionAccept: '.mp4, .mov',
              maxDuration: 900,
              confirmRemove: true,
              validations: {
                required: false
              },
              columnSize: 12
            },
          ],
          columnSize: 12,
        },
      ],
      ...labels,
    };

    form.values = values;

    return form;
  };

  useEffect(() => {
    const load = async () => {
      let values = {};

      values = await Fetch.post(paths.endpointGetById, { core_application_instance_id: session.user.application_instance_id, core_user_id: session.user.id });

      const form = getForm(values);
      setFormContent(<CustomFormContainer form={form} content={<CustomForm form={form} />} />);
    };
    load();
  }, []);

  return <div>{formContent}</div>;
}
export default Form;
